import { CardSvg } from '@/play/cardSvg'

/** Home card art: potion bottles on a shelf in a dark lab, one oozing pink into a copper cauldron. */
export function Ooze2CardArt() {
  return (
    <CardSvg bg="#1d1528">
      {(id) => (
        <>
          <defs>
            <radialGradient id={id('glow')} cx="0.5" cy="0.4" r="0.7">
              <stop offset="0" stopColor="#4a3566" />
              <stop offset="1" stopColor="#120d18" />
            </radialGradient>
          </defs>
          <rect width="320" height="200" fill={`url(#${id('glow')})`} />
          {/* shelf */}
          <rect x="40" y="86" width="240" height="8" rx="2" fill="#7a4a2a" />
          {/* round flask, pink, a hole on its right */}
          <circle cx="86" cy="64" r="20" fill="#e6f4ff" opacity="0.25" stroke="#cfe6ff" strokeWidth="2" />
          <rect x="81" y="30" width="10" height="16" fill="#e6f4ff" opacity="0.25" stroke="#cfe6ff" strokeWidth="2" />
          <path d="M68 70 a18 18 0 0 0 36 0 c-6 -3 -12 2 -18 0 s-12 -3 -18 0 z" fill="#ff3fb4" />
          <path d="M104 74 C 112 76, 116 82, 117 94 C 118 120, 120 140, 122 150" fill="none" stroke="#ff3fb4" strokeWidth="7" strokeLinecap="round" />
          {/* tall bottle: gold under cyan */}
          <rect x="146" y="40" width="26" height="46" rx="5" fill="#e6f4ff" opacity="0.25" stroke="#cfe6ff" strokeWidth="2" />
          <rect x="149" y="56" width="20" height="18" fill="#2ef2ff" />
          <rect x="149" y="74" width="20" height="10" rx="2" fill="#f0cf86" />
          {/* jar: silver */}
          <rect x="204" y="52" width="40" height="34" rx="5" fill="#e6f4ff" opacity="0.25" stroke="#cfe6ff" strokeWidth="2" />
          <rect x="207" y="60" width="34" height="24" rx="3" fill="#c9d1da" />
          {/* the copper cauldron over embers, its pool marbled pink and green, silver showing */}
          <ellipse cx="160" cy="194" rx="40" ry="6" fill="#ff7a24" opacity="0.8" />
          <path d="M84 150 h152 c0 26 -34 44 -76 44 s-76 -18 -76 -44 z" fill="#9a5530" />
          <ellipse cx="160" cy="150" rx="78" ry="12" fill="#c0743e" />
          <ellipse cx="160" cy="151" rx="70" ry="9" fill="#ff3fb4" />
          <path d="M120 150 c14 -5 30 4 44 0 s22 -5 34 1 c-12 5 -26 6 -40 4 s-26 0 -38 -5 z" fill="#6dff3a" />
          <ellipse cx="190" cy="152" rx="12" ry="3" fill="#c9d1da" />
          <path d="M106 148 C 124 145, 140 145, 150 146" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" opacity="0.6" />
        </>
      )}
    </CardSvg>
  )
}
